import axios from "axios";

const api = axios.create({
  baseURL:
    //process.env.REACT_APP_API_URL || "https://api.entrioai.com/entrio/api",
    process.env.REACT_APP_API_URL || "http://127.0.0.1:3000/entrio/api",
  headers: { "Content-Type": "application/json" },
});

// Request interceptor to add the auth token to every request
api.interceptors.request.use(
  (config) => {
    // 登录、注册等接口不加 token
    if (!config.url?.includes("/auth/login")) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const pathname = window.location.pathname;
      // 只在非登录/注册/重置页才跳转
      if (
        ![
          "/login",
          "/partner/setup",
          "/forgot-password",
          "/setup-password",
        ].some((p) => pathname.startsWith(p))
      ) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
